import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en.json';
import translationTR from './locales/tr.json';

import fileExplorerEN from './locales/en/FileExplorer.json';
import fileExplorerTR from './locales/tr/FileExplorer.json';

const resources = {
  en: {
    translation: translationEN,
    FileExplorer: fileExplorerEN
  },
  tr: {
    translation: translationTR,
    FileExplorer: fileExplorerTR
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'tr', // varsayılan dil
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n; 